import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 휴일 관리 - 공통 휴일 기준 상세
export const getHolidaysManager = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/holidays/manager")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴일 관리 - 공통 휴일 기준 수정
export const modifyHolidaysManager = (body) => {
  return new Promise((resolve, reject) => {
    http
      .put("/holidays/manager", body)
      .then((res) => {
        toast.success('공통 휴일이 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
